import React, { useState } from 'react';
import { HelpCircle } from 'lucide-react';

// Shared form building blocks, originally defined inline in Submit.js —
// extracted here once DeliveryForm.js became a second consumer, so the two
// forms never visually drift apart.

export function Section({ icon, title, subtitle, children }) {
  return (
    <div style={{ marginBottom: 32 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6, paddingBottom: 14, borderBottom: '1.5px solid var(--border)' }}>
        <div style={{ color: 'var(--pink)' }}>{icon}</div>
        <div>
          <h3 style={{ fontWeight: 800, fontSize: 15, color: 'var(--text)', letterSpacing: '-0.01em' }}>{title}</h3>
          {subtitle && <p style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 1, fontWeight: 400 }}>{subtitle}</p>}
        </div>
      </div>
      <div style={{ paddingTop: 4 }}>{children}</div>
    </div>
  );
}

// Small "?" glyph with a hover-revealed tooltip — used wherever a field's
// hint needs to stay out of the way until someone asks for it (opt in via
// Field's hintMode="icon").
export function HelpIcon({ text }) {
  const [open, setOpen] = useState(false);
  if (!text) return null;
  return (
    <span
      style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', marginLeft: 5, cursor: 'help' }}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      onClick={() => setOpen(o => !o)}
    >
      <HelpCircle size={13} color="var(--text-muted)" />
      {open && (
        <span style={{
          position: 'absolute', bottom: 'calc(100% + 8px)', left: '50%', transform: 'translateX(-50%)',
          width: 220, background: 'var(--bg-card)', border: '1.5px solid var(--border)', borderRadius: 'var(--r-md)',
          boxShadow: '0 8px 24px rgba(0,0,0,0.25)', padding: '10px 12px', fontSize: 11, fontWeight: 500,
          color: 'var(--text-secondary)', lineHeight: 1.5, textTransform: 'none', letterSpacing: 'normal', zIndex: 50,
        }}>
          {text}
        </span>
      )}
    </span>
  );
}

export function Field({ label, hint, hintMode, children, required }) {
  return (
    <div style={{ marginBottom: 18 }}>
      <label style={{ display: 'flex', alignItems: 'center', fontSize: 12, fontWeight: 700, color: 'var(--text-secondary)', marginBottom: 6, letterSpacing: '0.04em', textTransform: 'uppercase' }}>
        {label} {required && <span style={{ color: 'var(--pink)' }}>*</span>}
        {hintMode === 'icon' && <HelpIcon text={hint} />}
      </label>
      {hint && hintMode !== 'icon' && <p style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 8, fontWeight: 400 }}>{hint}</p>}
      {children}
    </div>
  );
}
